document.addEventListener("DOMContentLoaded", () => {
    (async function freeProductBar() {
        if(document.querySelector('.free-product-bar')){
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

            const cartDot = document.querySelector('cart-dot')
            const threshold = Number(document.querySelector('.free-product-bar').getAttribute('threshold'));
            const giftId = Number(document.querySelector('.free-product-bar').getAttribute('variant-id'));
            let thresholdReached = false;
            let giftInCart = false;
            let giftKey;

            if (cartContent.total_price > threshold) thresholdReached = true;

            if (cartContent && cartContent.items.length > 0) {
                for (const item of cartContent.items) {
                    for (const property in item.properties ) {
                        if (property == "_gift") {
                            giftInCart = true;
                            giftKey = item.key;
                            break;
                        }
                    }
                }
            }

            function addFreeProduct(freeProductID) {
                let formData = {
                'items': [{
                'id': freeProductID,
                'quantity': 1,
                'properties': {
                    '_gift': 'true'
                }
                }]
                };

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formData)
                })
                .then(() => {
                    if (window.themeVariables.settings.pageType === "cart") {
                        location.reload()
                    } else {
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                    }
                    cartDot.innerHTML = cartContent.item_count + 1;
                })
                .catch((error) => {console.error('Error:', error);});
            }

            function removeFreeProduct(freeProductKey) {
                fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    id: freeProductKey,
                    quantity: 0,
                    sections: ["sections--22807016931593__cart-drawer"]
                })
                })
                .then(() => {
                    if (window.themeVariables.settings.pageType === "cart") {
                        location.reload()
                    } else {
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                    }
                    cartDot.innerHTML = cartContent.item_count - 1 || '';
                })
                .catch((error) => {console.error('Error:', error);});
            }

            if (thresholdReached && !giftInCart && giftId && !localStorage.getItem("block_free_product")) {
                addFreeProduct(giftId);
            } else if (!thresholdReached && giftInCart && giftKey) {
                removeFreeProduct(giftKey);
                localStorage.removeItem("block_free_product");
            } else if (!thresholdReached){
                localStorage.removeItem("block_free_product");
            }
        }
        document.addEventListener("cart:change", ()=>{
            setTimeout(()=>{freeProductBar()})
        });
    })();
});


class ProductCardVideo extends HTMLElement {
  constructor() {
    super();
    this.pauseVideoButton = this.querySelector('.pause-video-button');
    this.playVideoButton = this.querySelector('.play-video-button');
    this.video = this.closest('product-card').querySelector('video');
    this.pauseVideoButton.addEventListener('click', () => {
      this.video.pause();
      this.playVideoButton.style.display = 'block';
      this.pauseVideoButton.style.display = 'none';
    });
    this.playVideoButton.addEventListener('click', () => {
      this.video.play();
      this.playVideoButton.style.display = 'none';
      this.pauseVideoButton.style.display = 'block';
    });
  }
}
customElements.define('product-card-video', ProductCardVideo);
